// Persistencia ligera en localStorage del widget.

const PREFIX = 'asesoria-chatbot:';

export const storage = {
  get visitorId(): string | undefined {
    try { return localStorage.getItem(`${PREFIX}visitor-id`) ?? undefined; } catch { return undefined; }
  },
  set visitorId(v: string | undefined) {
    try { v ? localStorage.setItem(`${PREFIX}visitor-id`, v) : localStorage.removeItem(`${PREFIX}visitor-id`); } catch {}
  },
  get conversationId(): string | undefined {
    try { return localStorage.getItem(`${PREFIX}conversation-id`) ?? undefined; } catch { return undefined; }
  },
  set conversationId(v: string | undefined) {
    try { v ? localStorage.setItem(`${PREFIX}conversation-id`, v) : localStorage.removeItem(`${PREFIX}conversation-id`); } catch {}
  },
  reset() {
    try {
      localStorage.removeItem(`${PREFIX}conversation-id`);
    } catch {}
  },
};
